import { Component, OnInit } from '@angular/core';
import { checkDomain } from '../Classes/checkDomain';
import crypto from 'crypto-js';
// import axios from 'axios';
import { Router } from '@angular/router';
import { ApiInterceptorInterceptor } from '../interceptor/api-interceptor.interceptor';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-oauth',
  templateUrl: './oauth.component.html',
  styleUrls: ['./oauth.component.css']
})
export class OauthComponent implements OnInit {

  constructor(public router: Router, private http: HttpClient) { }

  ngOnInit(): any {
    let urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');
    const type = urlParams.get('type');
    if (type === 'register') {
      const state = this.genRand(40);
      const verifier = this.genRand(128);
      const challenge = this.base64Url(crypto.SHA256(verifier));
      localStorage.setItem('state', state);
      localStorage.setItem('verifier', verifier);
      return (window.location.href =
        environment.HTTP +
        checkDomain() +
        '.'+environment.API_URL+'/oauth/authorize?client_id=3&redirect_uri='+ environment.HTTP +
        checkDomain() +
        '.'+environment.CLIENT_URL+'/oauthcallback&response_type=code&scope=*&state=' +
        state +
        '&code_challenge=' +
        challenge +
        '&code_challenge_method=S256');

      // return userStore.login();
    }
    if (code && state) {
      if (state === localStorage.getItem('state')) {
        let params = {
          grant_type: 'authorization_code',
          client_id: 3,
          redirect_uri: environment.HTTP + checkDomain() + '.'+environment.CLIENT_URL+'/oauthcallback',
          code_verifier: localStorage.getItem('verifier'),
          code,
        };

        const url = `${environment.HTTP}${checkDomain()}.${environment.API_URL}/oauth/token`;
        this.http.post<any>(url, params, { withCredentials: true }).subscribe({
          next: (resp) => {
            localStorage.removeItem('state');
            localStorage.removeItem('verifier');

            // save tokens
            localStorage.setItem('access_token', resp?.access_token);
            localStorage.setItem('refresh_token', resp?.refresh_token);

            // optional global interceptor state
            ApiInterceptorInterceptor.token = resp?.access_token;
            ApiInterceptorInterceptor.refresh_token = resp?.refresh_token;

            // navigate
            this.router.navigate(['/management'], { replaceUrl: true });
          },

          error: (e) => {
            console.error(e);
          }
        });

        // axios.defaults.withCredentials = true;
        // axios
        //   .post(environment.HTTP + checkDomain() + '.'+environment.API_URL+'/oauth/token', params)
        //   .then((resp) => {
        //     localStorage.removeItem('state');
        //     localStorage.removeItem('verifier');
        //     // save token
        //     localStorage.setItem('access_token', resp.data.access_token);
        //     localStorage.setItem('refresh_token', resp.data.refresh_token);
        //     ApiInterceptorInterceptor.token = resp.data.access_token;
        //     ApiInterceptorInterceptor.refresh_token = resp.data.refresh_token;
        //     return this.router.navigate(['/management'], { replaceUrl: true });

        //   })
        //   .catch((e) => {
        //     console.dir(e);
        //   });
      }
    }
  }

  genRand(num: number) {
    return [...Array(num)].map(() => Math.random().toString(36)[2]).join('');
  }
  base64Url(string: any) {
    return string
      .toString(crypto.enc.Base64)
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=/g, '');
  }

}
